import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

// Components
import Avatar from '../Avatar';
import CurrencyConverter from '../CurrencyConverter';
import ListCoverPhoto from '../ListCoverPhoto';
import Link from '../Link';
import ListNotFound from '../../routes/listNotFound/ListNotFound';
import NotFound from '../../routes/notFound/NotFound';

import { generateTime } from '../Receipt/helper';
import { formatTime } from '../../helpers/formatting';

// Locale
import messages from '../../locale/messages';

//Images
import Arrow from '/public/siteImages/rightSideArrow.svg';
import arrowIcon from '/public/SiteIcons/paymentArrow.svg';
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import starIcon from '/public/SiteIcons/star.svg';
import Faq from '../Receipt/question.svg';

import s from './Itinerary.css';
import cs from '../../components/commonStyle.css';

function tryFixJsonString(str) {
  if (typeof str !== 'string') return str;
  let fixed = str.trim();
  // Remove trailing commas before closing brackets
  fixed = fixed.replace(/,\s*([}\]])/g, '$1');
  // Close open array
  const openArr = (fixed.match(/\[/g) || []).length;
  const closeArr = (fixed.match(/\]/g) || []).length;
  if (openArr > closeArr) {
    fixed += ']'.repeat(openArr - closeArr);
  }
  // Close open object
  const openObj = (fixed.match(/{/g) || []).length;
  const closeObj = (fixed.match(/}/g) || []).length;
  if (openObj > closeObj) {
    fixed += '}'.repeat(openObj - closeObj);
  }
  return fixed;
}

class Itinerary extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.any,
    data: PropTypes.shape({
      id: PropTypes.number.isRequired,
      listId: PropTypes.number.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      guestServiceFee: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      reservationState: PropTypes.string.isRequired,
      isHourly: PropTypes.bool,
      megasoftVoucher: PropTypes.string,
      listData: PropTypes.shape({
        title: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
        zipcode: PropTypes.string.isRequired,
        reviewsCount: PropTypes.number.isRequired,
        reviewsStarRating: PropTypes.number.isRequired,
        listingData: PropTypes.shape({
          checkInStart: PropTypes.string.isRequired,
          checkInEnd: PropTypes.string.isRequired
        }),
        coverPhoto: PropTypes.number,
        listPhotos: PropTypes.arrayOf({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired
        }),
      }),
      messageData: PropTypes.shape({
        id: PropTypes.number.isRequired
      }),
      hostData: PropTypes.shape({
        profileId: PropTypes.number.isRequired,
        firstName: PropTypes.string.isRequired,
        picture: PropTypes.string.isRequired
      })
    })
  };

  static defaultProps = {
    data: null
  };

  render() {
    const { data } = this.props;
    const { formatMessage } = this.props.intl;
    const { userId } = this.props;

    if (data === null) {
      return <> <FormattedMessage {...messages.errorMessage} /> </>;
    } else if (data.listData === null) {
      return <ListNotFound />;
    } else if (data.paymentState !== "completed") {
      return <NotFound />
    } else {
      const { data, data: { startTime, endTime, listTitle, id, listId, checkIn, checkOut, megasoftVoucher, isHourly, total, guestServiceFee, currency, confirmationCode, reservationState, hostId, guestId, basePrice, delivery, discount, discountType, dayDifference, cameFromFeatured, featuredCommissionRate, featuredCommissionAmount } } = this.props;
      const { data: { hostData: { profileId, firstName, picture, createdAt } } } = this.props;
      const { data: { listData: { title, street, city, state, country, zipcode } } } = this.props;
      const { data: { listData: { coverPhoto, listPhotos, reviewsCount, reviewsStarRating, settingsData, transmission } } } = this.props;
      const { data: { listData: { listingData: { checkInStart, checkInEnd, hourlyPrice } } } } = this.props;
      const { data: { messageData, securityDeposit, bookingSpecialPricing, reservationAddons } } = this.props;

      let carType, transmissionLabel, isSpecialPricingAssinged, checkInDate, checkOutDate, formattedStartTime, formattedEndTime;
      let checkInTime, checkOutTime, isAverage = 0, dayPrice = 0, isDayTotal = 0;

      carType = settingsData && settingsData.length > 0 && settingsData[0].listsettings.itemName;
      transmission == '1' ? transmissionLabel = formatMessage(messages.Automatic) : transmissionLabel = formatMessage(messages.Manuall);
      isSpecialPricingAssinged = (bookingSpecialPricing && bookingSpecialPricing.length > 0) ? true : false;
      checkInDate = checkIn ? moment(checkIn).utc().format('ddd, MMM DD, YYYY ') : '';
      checkOutDate = checkOut ? moment(checkOut).utc().format('ddd, MMM DD, YYYY ') : '';

      if (isSpecialPricingAssinged) {
        bookingSpecialPricing && bookingSpecialPricing.map((item, index) => {
          dayPrice = dayPrice + Number(item.isSpecialPrice);
        });
      } else {
        dayPrice = basePrice * dayDifference;
      }

      if (checkInStart === 'Flexible') {
        checkInTime = formatMessage(messages.flexibleCheckIn);
      } else {
        checkInTime = generateTime(checkInStart);
      }

      if (checkInEnd === 'Flexible') {
        checkOutTime = formatMessage(messages.flexibleCheckOut);
      } else {
        checkOutTime = generateTime(checkInEnd);
      }

      let subTotal = basePrice * dayDifference;
      // Use stored processingFee from DB
      const storedProcessingFee = data.processingFee || 0;

      // Calculate add-ons total from reservation addons
      let addonsTotal = 0;
      if (reservationAddons && reservationAddons.length > 0) {
        addonsTotal = reservationAddons.reduce((sum, addon) => sum + (addon.totalPrice || 0), 0);
      }

      // SIMPLIFIED LOGIC: The 'total' field in DB already includes everything:
      // total = basePrice * days + guestServiceFee + processingFee + addonsTotal
      // We only need to add securityDeposit (if any)
      // 
      // The addons are displayed separately in the UI (from reservationAddons),
      // but they are ALREADY included in the 'total' value stored in DB.
      // DO NOT add addonsTotal again - it would cause double-counting.
      let subTotalWithSecurityDeposit = total + securityDeposit;
      let starRatingValue = 0;
      if (reviewsCount > 0 && reviewsStarRating > 0) {
        starRatingValue = Math.round(reviewsStarRating / reviewsCount)
      }

      let isHost = false;
      if (userId === hostId) {
        isHost = true;
      }

      // CRITICAL FIX: Always use startTime/endTime from DB for formatting
      // checkIn/checkOut are stored as midnight UTC, so they can't be used for time extraction
      // startTime/endTime contain the actual hours (e.g., 6 and 7 for 6:00 AM - 7:00 AM)
      formattedStartTime = formatTime(startTime);
      formattedEndTime = formatTime(endTime);

      // Calculate hourly difference using startTime/endTime for hourly bookings
      const hourDiff = endTime - startTime;
      const hourlyDifference = hourDiff >= 0 ? hourDiff : (24 - startTime + endTime);
      let joinedDate = createdAt != null ? moment(createdAt).format("MMM, YYYY") : '';

      isAverage = Number(dayPrice) / Number(dayDifference);
      isDayTotal = isAverage.toFixed(2) * dayDifference;
      dayPrice = isDayTotal;
      return (
        <Grid fluid className={s.container}>
          <Row className={cs.positionRelative}>
            <Col lg={7} sm={12} md={7} xs={12} className={cx(cs.spaceTop5, 'paymentDetailsPadding')}>
              {
                reservationState === "approved" && <h2 className={cx(cs.commonTitleText, cs.paddingBottom1, cs.fontWeightBold)}>
                  <FormattedMessage {...messages.itinerayTitle} />
                </h2>
              }
              <h4 className={cx(cs.commonContentText, cs.fontWeightNormal)}>
                <FormattedMessage {...messages.confirmationCode} />{' '}
                <span>{'#'}{confirmationCode}</span>
              </h4>
              <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom4, cs.spaceTop4)} />
              {
                !isHost && <>
                  <div className={cx(s.avatarImage, cs.paddingBottom4)}>
                    <Avatar
                      source={picture}
                      height={80}
                      width={80}
                      className={cs.profileAvatarLink}
                      withLink
                      profileId={profileId}
                    />
                    <div className={cx(s.textSection, 'viewListingTextSectionRTL')}>
                      <h5 className={cx(cs.commonSubTitleText, cs.fontWeightBold, cs.paddingBottom1)}>
                        <FormattedMessage {...messages.hostedBy} />{' '}
                        <a href={"/users/show/" + profileId} target={'_blank'} className={cx(cs.reviewTitleLink, cs.commonContentText)}>
                          <span className={cs.siteLinkColor}>{firstName}</span>
                        </a>
                      </h5>
                      <h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.paddingBottom1)}><FormattedMessage {...messages.joinedIn} /> {joinedDate}</h6>
                      {messageData && <Link to={"/message/" + messageData.id + "/renter"} className={cx(cs.siteLinkColor, cs.commomLinkborderBottom, cs.textDecorationNone, cs.fontWeightMedium)}>
                        <FormattedMessage {...messages.messageHost} />
                        <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                      </Link>}
                    </div>
                  </div>
                </>
              }
              <div className={cx(s.boxSection, cs.spaceBottom4)}>
                <div className={cx(s.displayFlexDate, cs.paddingBottom3, s.displayFlexDateMobile)}>
                  <h4 className={cx(cs.commonTotalText, cs.fontWeightBold)}>
                    <FormattedMessage {...messages.billing} />
                  </h4>
                  <Link to={"/users/trips/receipt/" + id} className={cx(cs.siteLinkColor, cs.commomLinkborderBottom, cs.textDecorationNone, cs.fontWeightMedium)}>
                    <FormattedMessage {...messages.viewReceipt} />
                    <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                  </Link>
                </div>
                <h4 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                  <div className={cs.dFlex}>
                    <div className={s.specialPriceIcon}>
                      {
                        isSpecialPricingAssinged &&
                        <span className={s.iconSection}>
                          <img src={Faq} className={cx(s.faqImage, 'faqImageRTL')} />
                        </span>
                      }
                      <div className={cx(s.toolTip, s.toolTipRelativeSection, 'toolTipRelativeSectionRTL', 'itneraryTipRTL')}>
                        <FormattedMessage {...messages.averageRate} />
                      </div>
                    </div>
                    <span>
                      <CurrencyConverter
                        amount={isHourly ? (hourlyPrice || basePrice) : basePrice}
                        from={currency}
                      />
                      <span className={s.billingArrow}>x</span>
                      {
                        isHourly ?
                          <>
                            {hourlyDifference} {hourlyDifference > 1 ? "Hours" : "Hour"}
                          </>
                          :
                          <>
                            {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
                          </>

                      }
                    </span>
                  </div>
                  {
                    isHourly ?
                      <>
                        <CurrencyConverter
                          amount={(hourlyPrice || basePrice) * hourlyDifference}
                          from={currency}
                        />
                      </>

                      :
                      <>
                        <CurrencyConverter
                          amount={dayPrice}
                          from={currency}
                        />
                      </>
                  }

                </h4>
                <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                {delivery > 0 && <><h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                  <FormattedMessage {...messages.cleaningFee} />
                  <CurrencyConverter
                    amount={delivery}
                    from={currency}
                  />
                </h5>
                  <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                </>
                }
                {discount > 0 && <><h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                  {discountType}
                  <span className={s.discountColor}>{"-"}<CurrencyConverter
                    amount={discount}
                    from={currency}
                  /></span>
                </h5>
                  <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                </>
                }
                {guestServiceFee > 0 && <><h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                  <FormattedMessage {...messages.serviceFee} />
                  <CurrencyConverter
                    amount={guestServiceFee}
                    from={currency}
                  />
                </h5>
                  <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                </>
                }
                {storedProcessingFee > 0 && <><h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                  <FormattedMessage {...messages.processingFee} />
                  <CurrencyConverter
                    amount={storedProcessingFee}
                    from={currency}
                  />
                </h5>
                  <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                </>
                }
                {securityDeposit > 0 && <><h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                  <FormattedMessage {...messages.securityDeposit} />
                  <CurrencyConverter
                    amount={securityDeposit}
                    from={currency}
                  />
                </h5>
                  <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                </>
                }
                {/* Reservation Add-ons */}
                {reservationAddons && reservationAddons.length > 0 && reservationAddons.map((addon, index) => (
                  <React.Fragment key={addon.id || index}>
                    <h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)}>
                      <span>{addon.name} {addon.quantity > 1 ? `(x${addon.quantity})` : ''}</span>
                      <CurrencyConverter
                        amount={addon.totalPrice}
                        from={currency}
                      />
                    </h5>
                    <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                  </React.Fragment>
                ))}
                {/* Featured Commission - Show only to host */}
                {cameFromFeatured && featuredCommissionAmount > 0 && userId === hostId && (
                  <>
                    <h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.displayFlexDate, s.displayFlexDateMobile)} style={{ color: '#D97706' }}>
                      Comisión Featured ({featuredCommissionRate}%)
                      <span style={{ color: '#D97706' }}>
                        -<CurrencyConverter
                          amount={featuredCommissionAmount}
                          from={currency}
                        />
                      </span>
                    </h5>
                    <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
                  </>
                )}
                <h6 className={cx(cs.commonContentText, cs.fontWeightBold, s.displayFlexDate, s.displayFlexDateMobile)}>
                  <FormattedMessage {...messages.totalPaid} />
                  <CurrencyConverter
                    amount={subTotalWithSecurityDeposit}
                    from={currency}
                  />
                </h6>
                {/* ═══════════════════════════════════════════════════════════════════════ */}
                {/* PREMIUM DIGITAL VOUCHER - Ticket Style                                    */}
                {/* ═══════════════════════════════════════════════════════════════════════ */}
                {megasoftVoucher && (() => {
                  try {
                    let parsed;
                    try {
                      parsed = typeof megasoftVoucher === 'string' ? JSON.parse(megasoftVoucher) : megasoftVoucher;
                    } catch (e) {
                      const fixed = tryFixJsonString(megasoftVoucher);
                      try {
                        parsed = JSON.parse(fixed);
                      } catch (e2) {
                        parsed = null;
                      }
                    }

                    // Premium Voucher Styles
                    const voucherStyles = {
                      container: {
                        background: '#FFFFFF',
                        borderRadius: '20px',
                        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.12)',
                        margin: '24px 0',
                        overflow: 'hidden',
                        maxWidth: '440px'
                      },
                      header: {
                        background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                        padding: '32px 24px',
                        textAlign: 'center',
                        color: 'white'
                      },
                      checkIcon: {
                        width: '72px',
                        height: '72px',
                        background: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px',
                        fontSize: '36px'
                      },
                      headerTitle: {
                        fontSize: '24px',
                        fontWeight: '700',
                        margin: '0 0 4px 0'
                      },
                      headerSubtitle: {
                        fontSize: '14px',
                        opacity: '0.9',
                        margin: '0'
                      },
                      tear: {
                        height: '20px',
                        background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                        position: 'relative'
                      },
                      body: {
                        padding: '24px'
                      },
                      dataRow: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 0',
                        borderBottom: '1px dashed #E5E7EB'
                      },
                      dataLabel: {
                        fontSize: '14px',
                        color: '#6B7280'
                      },
                      dataValue: {
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#1F2937',
                        fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace"
                      },
                      amountBox: {
                        background: 'linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%)',
                        borderRadius: '12px',
                        padding: '20px',
                        textAlign: 'center',
                        margin: '20px 0'
                      },
                      amountLabel: {
                        fontSize: '12px',
                        color: '#6B7280',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        marginBottom: '4px'
                      },
                      amountValue: {
                        fontSize: '32px',
                        fontWeight: '700',
                        color: '#1F2937',
                        fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace"
                      },
                      referenceBox: {
                        background: '#F9FAFB',
                        border: '2px dashed #D1D5DB',
                        borderRadius: '12px',
                        padding: '16px',
                        textAlign: 'center',
                        margin: '20px 0'
                      },
                      referenceCode: {
                        fontSize: '20px',
                        fontWeight: '700',
                        color: '#1F2937',
                        fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace",
                        letterSpacing: '2px'
                      },
                      footer: {
                        background: '#F9FAFB',
                        padding: '16px 24px',
                        textAlign: 'center',
                        borderTop: '1px solid #E5E7EB',
                        fontSize: '12px',
                        color: '#9CA3AF'
                      }
                    };

                    if (typeof parsed === 'object' && parsed !== null) {
                      const amount = parsed.monto || parsed.amount || parsed.TotalBs;
                      const reference = parsed.referencia || parsed.control || parsed.authid || parsed.factura;
                      const approval = parsed.aprobacion || parsed.authname || parsed.descripcion || parsed.codigo;
                      const date = parsed.fecha || new Date().toLocaleDateString('es-VE');
                      const time = parsed.hora || new Date().toLocaleTimeString('es-VE');

                      // Lista completa de campos a mostrar con nombres amigables
                      const fieldLabels = {
                        control: 'Control',
                        codigo: 'Código',
                        descripcion: 'Descripción',
                        vtid: 'VTID',
                        seqnum: 'Secuencia',
                        authid: 'Auth ID',
                        authname: 'Autorización',
                        factura: 'Factura',
                        referencia: 'Referencia',
                        terminal: 'Terminal',
                        lote: 'Lote',
                        rifba: 'RIF Banco',
                        monto: 'Monto',
                        fecha: 'Fecha',
                        hora: 'Hora',
                        cuenta: 'Cuenta',
                        pan: 'PAN',
                        aprobacion: 'Aprobación',
                        status: 'Estado',
                        tarjeta: 'Tarjeta',
                        banco: 'Banco',
                        cliente: 'Cliente',
                        telefono: 'Teléfono',
                        email: 'Email',
                        cedula: 'Cédula',
                        tipo: 'Tipo',
                        moneda: 'Moneda',
                        bancoDestino: 'Banco Destino',
                        bancoOrigen: 'Banco Origen',
                        cuentaDestino: 'Cuenta Destino',
                        cuentaOrigen: 'Cuenta Origen',
                        comercio: 'Comercio',
                        pos: 'POS',
                        c2p: 'C2P',
                        p2c: 'P2C',
                        zelle: 'Zelle',
                        zelleRef: 'Zelle Ref',
                        zelleName: 'Zelle Nombre',
                        zelleEmail: 'Zelle Email',
                        zellePhone: 'Zelle Teléfono',
                        zelleBank: 'Zelle Banco',
                        zelleDate: 'Zelle Fecha',
                        zelleTime: 'Zelle Hora',
                        zelleAmount: 'Zelle Monto',
                        zelleStatus: 'Zelle Estado'
                      };

                      // Campos que ya se muestran destacados (no repetir)
                      const highlightedFields = ['monto', 'amount', 'TotalBs', 'referencia', 'control', 'authid', 'factura'];

                      return (
                        <div style={voucherStyles.container}>
                          {/* Success Header */}
                          <div style={voucherStyles.header}>
                            <div style={voucherStyles.checkIcon}>✓</div>
                            <h3 style={voucherStyles.headerTitle}>¡Pago Aprobado!</h3>
                            <p style={voucherStyles.headerSubtitle}>Tu transacción fue procesada exitosamente</p>
                          </div>

                          {/* Tear Effect */}
                          <div style={{
                            height: '20px',
                            background: 'radial-gradient(circle at 10px 0, #FFFFFF 10px, transparent 10px) repeat-x',
                            backgroundSize: '20px 20px',
                            marginTop: '-10px'
                          }}></div>

                          {/* Body */}
                          <div style={voucherStyles.body}>
                            {/* Amount */}
                            {amount && (
                              <div style={voucherStyles.amountBox}>
                                <div style={voucherStyles.amountLabel}>Monto Total</div>
                                <div style={voucherStyles.amountValue}>
                                  Bs {Number(amount).toLocaleString('es-VE', { minimumFractionDigits: 2 })}
                                </div>
                              </div>
                            )}

                            {/* Reference */}
                            {reference && (
                              <div style={voucherStyles.referenceBox}>
                                <div style={{ fontSize: '11px', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>
                                  Número de Referencia
                                </div>
                                <div style={voucherStyles.referenceCode}>{reference}</div>
                              </div>
                            )}

                            {/* ALL Data Rows - Mostrar TODOS los campos */}
                            <div style={{ marginTop: '16px' }}>
                              {Object.keys(parsed).map((key, index, arr) => {
                                // Saltar campos internos o ya destacados
                                if (key === 'voucher' || highlightedFields.includes(key)) return null;

                                let value = parsed[key];
                                if (value === null || value === undefined || value === '') return null;
                                if (Array.isArray(value)) value = value.join(', ');
                                if (typeof value === 'object') value = JSON.stringify(value);

                                const label = fieldLabels[key] || key.charAt(0).toUpperCase() + key.slice(1);
                                const isLast = index === arr.length - 1;
                                const isStatus = key === 'descripcion' || key === 'aprobacion' || key === 'status' || key === 'codigo';

                                return (
                                  <div key={key} style={{ ...voucherStyles.dataRow, borderBottom: isLast ? 'none' : '1px dashed #E5E7EB' }}>
                                    <span style={voucherStyles.dataLabel}>{label}</span>
                                    <span style={{
                                      ...voucherStyles.dataValue,
                                      color: isStatus ? '#10B981' : '#1F2937',
                                      maxWidth: '200px',
                                      textAlign: 'right',
                                      wordBreak: 'break-word'
                                    }}>{String(value)}</span>
                                  </div>
                                );
                              })}

                              {/* Fecha/Hora al final */}
                              <div style={{ ...voucherStyles.dataRow, borderBottom: 'none', marginTop: '8px', paddingTop: '16px', borderTop: '1px solid #E5E7EB' }}>
                                <span style={voucherStyles.dataLabel}>📅 Fecha/Hora</span>
                                <span style={voucherStyles.dataValue}>{date} {time}</span>
                              </div>
                            </div>
                          </div>

                          {/* Footer */}
                          <div style={voucherStyles.footer}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                              <span>🔒</span>
                              <span>Procesado por Megasoft</span>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      // Fallback for unparseable voucher
                      return (
                        <div style={{ ...voucherStyles.container, padding: '24px' }}>
                          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                            <span style={{ fontSize: '48px' }}>✓</span>
                            <h3 style={{ color: '#10B981', margin: '8px 0' }}>Pago Procesado</h3>
                          </div>
                          <details style={{ background: '#F9FAFB', borderRadius: '8px', padding: '12px' }}>
                            <summary style={{ cursor: 'pointer', fontWeight: '600', color: '#5469d4' }}>
                              Ver detalles técnicos
                            </summary>
                            <pre style={{
                              background: '#1F2937',
                              color: '#10B981',
                              borderRadius: '8px',
                              padding: '16px',
                              marginTop: '12px',
                              fontSize: '12px',
                              whiteSpace: 'pre-wrap',
                              wordBreak: 'break-all',
                              fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace"
                            }}>{megasoftVoucher}</pre>
                          </details>
                        </div>
                      );
                    }
                  } catch (e) {
                    return null;
                  }
                })()}
              </div>
              <div className={s.boxSection}>
                <h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}>
                  <FormattedMessage {...messages.tripDetails} />
                </h4>
                <div className={s.displayFlexDate}>
                  <h5 className={cx(cs.commonContentText, cs.fontWeightBold)}>
                    <FormattedMessage {...messages.checkIn} />
                    <span className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.displayBlock, cs.paddingBottom1, cs.paddingTop2)}>{checkInDate}</span>
                    <span className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{formattedStartTime}</span>
                  </h5>
                  <img src={arrowIcon} className={cx(cs.dateArrowMargin, 'commonDateArrowRTLRotate')} />
                  <h5 className={cx(cs.commonContentText, cs.fontWeightBold)}>
                    <FormattedMessage {...messages.checkOut} />
                    <span className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.displayBlock, cs.paddingBottom1, cs.paddingTop2)}>{checkOutDate}</span>
                    <span className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{formattedEndTime}</span>
                  </h5>
                </div>
                <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom3, cs.spaceTop3)} />
                <>
                  <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}>
                    <FormattedMessage {...messages.location} />
                  </h4>
                  <h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1)}>
                    <span>{street}, </span>
                    <span>{city}, {state}, {zipcode}</span>
                    <span>{' '}{country}.</span>
                  </h6>
                  <a href={"/boats/" + listId} target={'_blank'} className={cx(cs.siteLinkColor, cs.commomLinkborderBottom, cs.textDecorationNone, cs.fontWeightMedium)}>
                    <FormattedMessage {...messages.viewListing} />
                    <img src={Arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                  </a>
                </>
              </div>
            </Col>
            <Col lg={5} md={5} sm={12} xs={12} className={cx(cs.spaceTop7, cs.paymentSticky)}>
              <div className={cx(s.imgBgColor, s.boxSection)}>
                <div className={cx(cs.positionRelative, cs.displayBlock)}>
                  <a href={"/boats/" + listId} target={"_blank"}>
                    {listPhotos && listPhotos.length > 0 && (
                      <div
                        className={cx(s.imageContent, cs.spaceBottom1)}
                        style={{
                          backgroundImage: `url(/images/upload/${listPhotos[0].name})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                          width: '100%',
                          height: '200px',
                          borderRadius: '8px'
                        }}
                      />
                    )}
                  </a>
                  <div className={cx(cs.positionAvatar, 'positionAvatarRTL', s.zIndex)}>
                    <Avatar
                      source={picture}
                      title={firstName}
                      className={cx(cs.profileAvatarLink, cs.profileAvatarLinkSmall)}
                      withLink
                      width={44}
                      height={44}
                      profileId={profileId}
                      linkClassName={cs.displayInlineBlock}
                    />
                  </div>
                </div>
                <>
                  <div className={cx(s.displayFlex, cs.spaceTop3)}>
                    <img src={steeringIcon} className={'commonIconSpace'} />
                    <h6 className={cx(cs.commonSmallText, cs.fontWeightNormal)}>
                      <span>{carType}</span>
                      <span className={cs.dotCss}></span>
                      <span>{transmissionLabel}</span>
                    </h6>
                  </div>
                  <a href={"/boats/" + listId} target={"_blank"} className={cx(cs.spaceTop1, cs.commonContentText, cs.siteTextColor, cs.displayBlock, cs.fontWeightBold)}>
                    {listTitle ? listTitle : title}
                  </a>
                  {starRatingValue > 0 && <div className={cx(cs.spaceTop1, cs.commonContentText, s.displayFlex)}>
                    <img src={starIcon} className={'searchHeaderIcon'} /> <span>{starRatingValue}</span>
                  </div>}
                </>
              </div>
            </Col>
          </Row>
        </Grid>
      );
    }
  }
}

const mapState = (state) => ({
  userId: state?.account?.data?.userId
});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(Itinerary)));